import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominaTimbresTimbrarConfirmarComponent {
  idProyecto
  idNomina
  serie
  data
  omitidos
  onClose
  versionFactura

  constructor($filter) {
    this.$filter = $filter
  }

  /*function $onInit() {
  NominasNominaInformacionFechapago.get($ctrl.idProyecto, $ctrl.idNomina)
    .then(function (response) {
      $ctrl.fecha = new Date();

      if ($ctrl.fecha.getMonth() === 2 && response.data.fecha_pago.getMonth() === 1) {
        $ctrl.fecha.setMonth(1);
        $ctrl.fecha.setDate(28);
      }

      $ctrl.fechaMin = new Date();
      $ctrl.fechaMax = new Date();
      $ctrl.fechaMin.setDate($ctrl.fechaMin.getDate() - 3);

      $ctrl.completado = true;
    });
}*/

  $onInit () {
    this.fecha = new Date()
    this.fechaMin = new Date(this.fecha)
    this.fechaMax = new Date(this.fecha)
    this.fechaMin.setDate(this.fechaMin.getDate() - 3)
  }

  aceptar () {
    this.onClose({
      $event: {
        data: {
          version: this.versionFactura,
          fecha: this.$filter('date')(this.fecha, 'yyyy-MM-ddTHH:mm:ss'),
        },
      },
    })
  }

  cancelar () {
    this.onClose({ $event: {} })
  }
}

module.component('nominaTimbresTimbrarConfirmar', {
  controller: NominaTimbresTimbrarConfirmarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    serie: '<',
    data: '<',
    omitidos: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/timbrar/confirmar/component.js